<script lang="ts">
	// @ts-ignore
	import SquarePlusSolid from "svelte-awesome-icons/SquarePlusSolid.svelte";

	export let deviceType: any;

	let promptWrapper: HTMLElement;
	let installDetails: HTMLElement;

	const showInstallDetails = () => {
		installDetails.classList.toggle("hidden");
	};

	const ignorePrompt = () => {
		promptWrapper.classList.toggle("hidden");
	};
</script>

<div
	bind:this={promptWrapper}
	class="pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6 animate-appearFromBottom z-50"
>
	<div
		class="pointer-events-auto mx-auto max-w-xl rounded-xl bg-white p-6 shadow-lg ring-1 ring-gray-200/10"
	>
		<div class="flex space-x-6">
			<img
				src="/maskable.png"
				class="h-12 w-12 shadow rounded-lg self-center justify-center"
				alt=""
			/>
			<div class="flex-1">
				<p class="text-sm leading-6 text-gray-900 font-semibold">
					You can add Less Waste to your home screen
				</p>
				<div class="mt-4 flex items-center gap-x-5">
					<p class="text-gray-500 text-sm">
						Less Waste takes little to no storage space, works offline, and is available on all your
						devices!
					</p>
				</div>
				<button
					on:click={() => showInstallDetails()}
					type="button"
					class="block w-3/4 mt-4 rounded-md bg-opal px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
					>Add</button
				>
				<button
					on:click={() => ignorePrompt()}
					type="button"
					class="block mt-4 text-xs text-gray-600 hover:underline">No, thanks</button
				>
			</div>
		</div>
	</div>
</div>

<div
	bind:this={installDetails}
	class="hidden pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6 animate-appearFromBottom z-50"
>
	<div
		class="pointer-events-auto mx-auto max-w-xl rounded-xl bg-white p-6 shadow-lg ring-1 ring-gray-200/10"
	>
		<div class="flex justify-end">
			<button
				on:click={() => {
					showInstallDetails();
					ignorePrompt();
				}}
				type="button"
				class="text-xs text-gray-600 hover:underline">Close</button
			>
		</div>
		<div class="p-2">
			<p class="text-sm tracking-tight text-gray-600">
				Use it as any other app on your homescreen<br />No download required.
			</p>
			<ul role="list" class="mt-8 max-w-xl space-y-8 text-gray-600">
				<li class="flex items-center">
					{#if deviceType == "MacOS"}
						<img src="/install-pwa.png" class="mr-2 w-8 h-8" alt="" />
						<span
							><strong class="font-semibold text-gray-900">1</strong> Press
							<b class="text-opal">Download</b> next to your bookmarks</span
						>
					{:else}
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							class="mr-2 w-8 h-8"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
							/>
						</svg>
						<span
							><strong class="font-semibold text-gray-900">1</strong> Press
							<b class="text-opal">Share</b> in the menu below</span
						>
					{/if}
				</li>
				<li class="flex items-center">
					<SquarePlusSolid class="mr-2 flex p-1 w-8 h-8" />
					{#if deviceType == "MacOS"}
						<span
							><strong class="font-semibold text-gray-900">2</strong> Click
							<b class="text-opal">Install</b></span
						>
					{:else}
						<span
							><strong class="font-semibold text-gray-900">2</strong> Click
							<b class="text-opal">Add to Home Screen</b></span
						>
					{/if}
				</li>
			</ul>
		</div>
	</div>
</div>
